import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { ContextItem } from '@flowx/designer/modules/ai/common/api/conversation-api.types'
import { BulkUpdateProcessEntitiesResponse } from '@flowx/designer/shared/entities/process-api.types'

import {
  AiProcessEntities,
  DocumentContextReference,
  GenerateProcessResponse,
  SendFeedbackPayload,
} from '../../../types/ai.types'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiAnalystActions = createActionGroup({
  source: 'AiAnalyst',
  events: {
    generateProcessFromDocument: props<{ documentContextReference: DocumentContextReference }>(),
    generateProcessFromImages: props<{
      files: File[]
      prompt: string
    }>(),
    generateProcessFromBpmnFiles: props<{
      files: File[]
      prompt: string
    }>(),

    generate: props<{ prompt: string }>(),
    generateProcess: props<{ prompt: string }>(),
    insertInProcess: props<{ prompt: string }>(),
    generateProcessSuccess: props<{
      response: GenerateProcessResponse
      aiEntities: AiProcessEntities
    }>(),
    generateProcessFailure: errorProps(),

    keepOutcome: emptyProps(),
    keepProcessDraftSuccess: props<{ response: BulkUpdateProcessEntitiesResponse }>(),
    keepProcessDraftFailure: errorProps(),
    keepOutcomeSuccess: props<{ response: BulkUpdateProcessEntitiesResponse }>(),
    discardProcessDraft: emptyProps(),
    discardOutcome: emptyProps(),
    discardOutcomeSuccess: emptyProps(),

    sendFeedback: props<{ payload: SendFeedbackPayload }>(),
    beginAssigningPagesToUserTasks: emptyProps(),
    assignPagesToUserTasksSuccess: emptyProps(),
    assignPagesToUserTasksFailed: emptyProps(),
    summaryChangesReceived: props<{
      messageText: string
      contextDataItems: ContextItem[]
    }>(),
  },
})
